import * as z from "zod";
import {
  carrierRateChangeSetSchema,
  carrierRateReviewSchema,
} from "./carrier-rate-change-set";

export const getCarrierRateChangeSet = {
  name: "getCarrierRateChangeSet" as const,
  input: z.object({ id: z.string() }),
  output: carrierRateReviewSchema.extend({
    changeSet: carrierRateChangeSetSchema,
  }),
};
